import type * as React from 'react';
import { putFormData } from '@Domain/Api';
import organizationLogoReplaced, {
	type OrganizationLogoReplacedAction,
} from '@Application/Branding/OrganizationLogo/Actions/organizationLogoReplaced';
import organizationLogoReplacementFailed, {
	type OrganizationLogoReplacementFailedAction,
} from '@Application/Branding/OrganizationLogo/Actions/organizationLogoReplacementFailed';
import type ReplaceOrganizationLogo from '@Application/Branding/OrganizationLogo/Commands/ReplaceOrganizationLogo';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationLogoReplacedAction | OrganizationLogoReplacementFailedAction;

export default (command: ReplaceOrganizationLogo) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await putFormData<void>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/logo`,
				command.toFormData(),
			);

			const action = organizationLogoReplaced({ organizationId: command.organizationId });
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationLogoReplacementFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
